
export {} from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$time-picker.js';
import __x__ from '../../../frontend-js-clay-web/__liferay__/exports/@clayui$time-picker.js';export default __x__;